import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import ModalLoading, { type IModalLoadingRef } from '@/components/ModalLoading';
import { useGlobalContext } from '@/context/global.context';

import { ROUTES } from '@/constants/routes.constants';
import type { IUserAuth } from '@/interfaces/model/user.interface';

import { getAcceso } from '../../services/login.service';

const Access = () => {
	const { setUser } = useGlobalContext();
	const modalLoadingGeneric = useRef<IModalLoadingRef>(null);
	const navigate = useNavigate();

	const autoLogin = async (code: string, state: string) => {
		if (!code || !state) {
			navigate(ROUTES.PORTADA);
			return;
		}

		// Carga el JWT para las consultas
		const { data, code: statusCode } = await getAcceso(code, state);

		if (statusCode === 200) {
			setUser(data as IUserAuth);
			modalLoadingGeneric?.current?.close();
			navigate(ROUTES.HOME);
		} else {
			let state = {};
			if (statusCode === 406) {
				state = { data };
			}
			navigate(ROUTES.PORTADA, state);
		}
	};

	useEffect(() => {
		modalLoadingGeneric?.current?.open();
		const query = new URLSearchParams(window.location.search);
		const code = query.get('code') ?? '';
		const state = query.get('state') ?? '';
		autoLogin(code, state);
	}, []);

	return (
		<ModalLoading
			ref={modalLoadingGeneric}
			descriptionTitle="Cargando acceso"
			description="Esta acción puede tardar varios minutos."
		/>
	);
};

export default Access;
